import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { track } from "@/lib/api";

export const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("page_view");
  }, [location.pathname]);
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
